import store from "@/store/index.js"
import Router from "@/router"
import {putObject} from '@/utils/upload.js'
export default {

	/**
	 * 判断一个值是否为空
	 * @param obj			任意类型
	 * @returns {boolean}	是否为空
	 */

	isNull(obj) {
		if (obj == undefined || obj == 'undefined' || obj == null || obj == 'null' || obj == "" || obj.length == 0 ||
			JSON.stringify(obj) == "{}") return true;
		else return false;
	},

	/**
	 * json转换
	 * @param {json|array:list}[列表:true] {string:key}[键名:true] {string|number:value}[键值:true]
	 * {number:types}[{0-数组}|{1-json}:false]
	 * @returns arr | json
	 */
	switchObject(list, key, value, types = 0) {
		if (types == 0) {
			let arr = []
			for (let attr in list) {
				const obj = {}
				obj[key] = attr
				obj[value] = list[attr]
				arr.push(obj)
			}

			return arr
		}

		let json = {}
		list.map(item => {
			const attr = item[key],
				value = item[value]
			json.attr = value
		})

		return json
	},

	/**
	 * 判断是否登录-不登录
	 * @param {function:fn}[回调:false]
	 * @returns boolean
	 */
	isTokenBooleanFn(fn) {
		if (this.isNull(store.getters.token)) {
			if (fn) fn();
			return false
		}
		if (fn) fn();
		return true
	},



	/**
	 * 返回
	 * @param null
	 * @returns null
	 */
	goReturn(num = 1) {
    num -= num
    Router.back(num)
	},

	/**
	 * json序列化
	 * @param {Object:json}[json:true]
	 * @returns Str
	 */
	serializeStr(json) {
		let arr = []
		for (let i in json) {
			arr.push(i + "=" + json[i]);
		}
		let str = arr.join('&')
		return str

	},
	/**
	 * 时间戳转时间格式
	 */
	formatDate(iDate) {
		let date = new Date(iDate);
		let YY = date.getFullYear() + '-';
		let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
		let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
		let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
		let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
		return YY + MM + DD + " " + hh + mm + ss;
	},

	isWeiXin() {
		const ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	},
	// 合并JSON
	extend(target, source) {
		for (var obj in source) {
			target[obj] = source[obj];
		}
		return target;
	},

	//判断当前设备是PC还是移动端
	isMobile() {
		if(!window.navigator) {
		    console.log("移动端");
		    return true
		  }
		  else{
		    if(/Mobile|Android|webOS|iPhone|iPad|Phone/i.test(navigator.userAgent)){
		      console.log("移动端");
		      return true
		    }
		    else{
		      console.log("pc端");
		      return false
		    }
		  }
	},

	//	退出登录
	signOut(){
		window.location.clearStorage();
		let a = setTimeout(()=>{
			clearTimeout(a)
      Router.push({
        name: "Login",
      })
		},500)
	},

	/**
	 * @Author HS
	 * @Date 2021/7/16 10:55 上午
	 * @Description: 乘法
	 * @Params: { number ： arg1 - true } [数字1]
	 * @Params: { number ： arg1 - true } [数字2]
	 * @Return: number
	*/
	accMul (arg1, arg2) {
		let m=0,s1=arg1.toString(),s2=arg2.toString();
		try{m+=s1.split(".")[1].length}catch(e){}
		try{m+=s2.split(".")[1].length}catch(e){}
		return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
	},
	/**
	 * @Author HS
	 * @Date 2021/7/16 10:55 上午
	 * @Description: 除法
	 * @Params: { number ： arg1 - true } [数字1]
	 * @Params: { number ： arg1 - true } [数字2]
	 * @Return: number
	 */
	accDiv (arg1, arg2) {
		let t1 = 0, t2 = 0, r1, r2;
		try {t1 = arg1.toString().split(".")[1].length} catch (e) {}
		try {t2 = arg2.toString().split(".")[1].length} catch (e) {}
		r1 = Number(arg1.toString().replace(".", ""))
		r2 = Number(arg2.toString().replace(".", ""))
		return this.accMul((r1 / r2), Math.pow(10, t2 - t1));
	},
	/**
	 * @Author HS
	 * @Date 2021/7/16 10:55 上午
	 * @Description: 加法
	 * @Params: { number ： arg1 - true } [数字1]
	 * @Params: { number ： arg1 - true } [数字2]
	 * @Return: number
	 */
	accAdd (arg1, arg2) {
		let r1,r2,m;
		try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
		try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
		m=Math.pow(10,Math.max(r1,r2))
		return (arg1*m+arg2*m)/m
	},
	/**
	 * @Author HS
	 * @Date 2021/7/16 10:55 上午
	 * @Description: 减法
	 * @Params: { number ： arg1 - true } [数字1]
	 * @Params: { number ： arg1 - true } [数字2]
	 * @Return: number
	 */
	subtr (arg1, arg2) {
		let r1,r2,m,n;
		try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
		try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
		m=Math.pow(10,Math.max(r1,r2));
		n=(r1>=r2)?r1:r2;
		return ((arg1*m-arg2*m)/m).toFixed(n);
	},

	/**
	 * @Author HS
	 * @Date 2021/7/16 10:55 上午
	 * @Description: 获取当前时间
	 * @Params: null
	 * @Return: string
	 */
	getTime() {
		let myDate = new Date();
		let y = myDate.getFullYear();
		let m = myDate.getMonth() + 1;
		let d = myDate.getDate();
		let h = myDate.getHours();
		let min = myDate.getMinutes() + 1;
		let s = myDate.getSeconds() + 1;
		let time = `${y}-${m}-${d} ${h}:${min}:${s}`;
		return time;
	},


	/**
	 * @Author: HS
	 * @Description: 字符串转json
	 * @Params: { string ：val - true } [值]
	 * @Return: string
	*/
   jsonParseFn(val){
	   if(this.isNull(val)) return val

	   if(val.indexOf("{") > -1){
		   return JSON.parse(val)
	   }
	   return val
   },

   /**
    * @Author: HS
    * @Description:
    * @Params: { string|array ：sJson - true } [json]
    * @Params: { string ：key - true } [key]
    * @Params: { string ：attr - false } [对比键]
    * @Return: boolean
   */
   setDefault(sJson,key,attr = 'key'){
	   if(this.isNull(sJson))return
	   let arr = [];
	   if(typeof sJson == "string"){
		   arr = JSON.parse(sJson)
	   }
	   else{
		   arr = sJson
	   }
	   let str = JSON.stringify(sJson)

	   // 数组
	   if(str.indexOf('[') > -1){
		   if(arr.length <= 0)return false
		   let a = arr.filter(item => item[attr] == key)
		   if(a.length > 0)return true
		   return false
	   }

	   if(arr[attr] == key) return true
	   return false


   },

   /**
    * @Author: HS
    * @Description: 获取不重复的随机整数
    * @Params: { object ：params - false } [params：随机数个数-length，最小值-min，最大值-max]
    * @Return: array
   */
   randomArr(params) {
     params = { ...{ length: 2, min: 1, max: 10 }, ...params };
     let { length, min, max } = params;
     if (
       typeof length != "number" ||
       typeof min != "number" ||
       typeof max != "number" ||
       max <= min ||
       length <= 0
     ) {
       return [];
     }
     if(max - min < length) {
       length = max - min + 1;
     }
     let arr = [];
     for (let i = 0; i < length; i++) {
       let num = Math.round(Math.random() * (max - min)) + min;
       if (!arr.includes(num)) {
         arr.push(num);
       } else {
         i-=1
       }
     }
     return arr;
   },

   /**
    * @Author: HS
    * @Description: 判断uc浏览器
    * @Params: null
    * @Return: string
   */
   getBrowser(){
		const OsObject=navigator.userAgent;
		const ua = navigator.userAgent.toLowerCase();
		if(OsObject.indexOf("Opera") != -1){return "Opera"}
		if(OsObject.indexOf("MSIE") != -1){return "Internet Explorer"}

		if(OsObject.indexOf("BIDUBrowser") != -1){return "BIDUBrowser"}
		if(OsObject.indexOf("Firefox") != -1){return "Firefox"}
		if(OsObject.indexOf("Netscape") != -1){return "Netscape"}
		if(ua.match(/MicroMessenger/i)=="micromessenger"){return "weixn"}

		if(OsObject.indexOf("Chrome") != -1){
			if(OsObject.indexOf("UCBrowser") != -1) {return "UCBrowser"}
			return "chrome"
		}
		if(OsObject.indexOf("Safari") != -1){
			if(OsObject.indexOf("UCBrowser") != -1) {return "UCBrowser"}
			return "Safari"
		}

		return "未知"
   },

    /**
    * @Author: HS
    * @Description: 获取当前地址
    * @Params: null
    * @Return: string
    */
    getUrl(){
      const url = window.location.href
      if(this.isNull(url))return ''
      let sUrl = url.split('#')
      return sUrl[0]
    },
	
	/**
	* @Author: HS
	* @Description: 剔除空值
	* @Params: null
	* @Return: obj
	*/
	cullJson(json){
		let obj = {}
		for (let attr in json) {
			if(!this.isNull(json[attr])){
				obj[attr] = json[attr]
			}
		}
		return obj
	}


}
